/**
 * @generated SignedSource<<0982143d32aad80a2b1a3b2b58ef7131>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssignHotelToPackageDialog_package$data = {
  readonly id: string;
  readonly " $fragmentType": "AssignHotelToPackageDialog_package";
};
export type AssignHotelToPackageDialog_package$key = {
  readonly " $data"?: AssignHotelToPackageDialog_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"AssignHotelToPackageDialog_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AssignHotelToPackageDialog_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "4d3a8c559706a531b7827ceb8d25e3cf";

export default node;
